var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuizerFooterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    height: 247,
    viewBox: "0 0 247 247",
    width: 247,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 123.812,
    cy: 123.562,
    fill: "#aaed37",
    r: 123.188
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m137.665 153.836 24.282 19.253-10.334 9.056-23.838-19.063zm24.473-36.352v5.066c0 6.967-.909 13.215-2.727 18.746-1.817 5.531-4.417 10.239-7.798 14.123s-7.418 6.861-12.109 8.93c-4.692 2.027-9.89 3.04-15.596 3.04-5.664 0-10.842-1.013-15.533-3.04-4.65-2.069-8.686-5.046-12.1096-8.93s-6.0863-8.592-7.9883-14.123c-1.8597-5.531-2.7896-11.779-2.7896-18.746v-5.066c0-6.967.9299-13.194 2.7896-18.6831 1.8597-5.531 4.4802-10.2386 7.8615-14.1229 3.4236-3.9266 7.4604-6.9031 12.1094-8.9297 4.691-2.0689 9.869-3.1033 15.533-3.1033 5.706 0 10.905 1.0344 15.596 3.1033 4.734 2.0266 8.791 5.0031 12.173 8.9297 3.381 3.8843 5.98 8.5919 7.798 14.1229 1.86 5.4891 2.79 11.7161 2.79 18.6831zm-15.977 5.066v-5.193c0-5.151-.507-9.69-1.522-13.616-.972-3.969-2.43-7.2834-4.374-9.9433-1.902-2.7021-4.248-4.7287-7.038-6.0798-2.747-1.3933-5.896-2.0899-9.446-2.0899-3.466 0-6.573.6966-9.32 2.0899-2.747 1.3511-5.093 3.3777-7.037 6.0798-1.945 2.6599-3.424 5.9743-4.438 9.9433-1.015 3.926-1.522 8.465-1.522 13.616v5.193c0 5.151.507 9.711 1.522 13.68 1.014 3.969 2.493 7.325 4.438 10.069 1.986 2.703 4.353 4.75 7.1 6.144 2.79 1.351 5.918 2.026 9.384 2.026 3.55 0 6.699-.675 9.446-2.026 2.747-1.394 5.072-3.441 6.974-6.144 1.902-2.744 3.339-6.1 4.311-10.069 1.015-3.969 1.522-8.529 1.522-13.68z",
    fill: "#394854"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizerFooterLogo);
export default __webpack_public_path__ + "static/media/quizer-footer-logo.8f66874bde2766881f044e8d3577091e.svg";
export { ForwardRef as ReactComponent };